exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigation{position:relative;width:100%;height:100px;display:flex;align-items:center}.backgroundVideo{position:fixed;right:0;bottom:0;min-width:100%;min-height:100vh;object-fit:cover}.menu_icon{left:20px}.logo,.menu_icon{position:absolute;z-index:999}.logo{right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ec847a00","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppNavigation.vue
// module id = 26
// module chunks = 0